import { render } from "./ValidateRecordButton.vue?vue&type=template&id=2a9418bc&scoped=true"
import script from "./ValidateRecordButton.vue?vue&type=script&lang=ts"
export * from "./ValidateRecordButton.vue?vue&type=script&lang=ts"

import "./ValidateRecordButton.vue?vue&type=style&index=0&id=2a9418bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a9418bc"

export default script